import stgConfig from './stg.json';
import prodConfig from './prod.json';
import devcsi1Config from './devcsi1.json';
import devcsi2Config from './devcsi2.json';
import devbfs1Config from './devbfs1.json';
import devbfs2Config from './devbfs2.json';
import stgpreviewConfig from './stgpreview.json';
import demoConfig from './demo.json';
import csodConfig from './csod.json';
import deloitteConfig from './deloitte.json';
import trial1Config from './trial1.json';
import trial2Config from './trial2.json';
import caprod from './caprod.json';
import dt1Config from './dt1.json';
import dt2Config from './dt2.json';
import dt3Config from './dt3.json';
import dt4Config from './dt4.json';
import devcsi3Config from './devcsi3.json';

const envFiles = new Map([
  ['stg', stgConfig],
  ['prod', prodConfig],
  ['devcsi1', devcsi1Config],
  ['devcsi2', devcsi2Config],
  ['devcsi3', devcsi3Config],
  ['devbfs1', devbfs1Config],
  ['devbfs2', devbfs2Config],
  ['stgpreview', stgpreviewConfig],
  ['demo', demoConfig],
  ['csod', csodConfig],
  ['deloitte', deloitteConfig],
  ['trial1', trial1Config],
  ['trial2', trial2Config],
  ['caprod', caprod],
  ['dt1', dt1Config],
  ['dt-1', dt1Config],
  ['dt2', dt2Config],
  ['dt-2', dt2Config],
  ['dt3', dt3Config],
  ['dt-3', dt3Config],
  ['dt4', dt4Config],
  ['dt-4', dt4Config],
]);

class EnvConfig {
  _env: string;

  constructor(env: string) {
    this._env = env;
  }

  getConfig() {
    return envFiles.get(this._env) || {};
  }
}

const envConfig = new EnvConfig(process.env.REACT_APP_APP_ENV || 'local');

export default envConfig;
